
import React, { Component } from 'react';

import Lg from "language"
import Ls from "localStore"
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import Button from "components/CustomButtons/Button"
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

//Component==================
import Chart1 from "./chart1"
import Chart1NPS from "./chart1NPS"
import Chart1Detail from "./chart1Detail"
import Chart1DetailL2 from "./chart1DetailL2"
import Chart1L2 from "./chart1L2"
import Chart1L3 from "./chart1L3"
import Chart2 from "./chart2"
import Chart3 from "./chart3"
import Chart4 from "./chart4"

//ICON==================
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

class PChart extends Component {
	constructor() {
		super();
		this.state = {
			select_region_service_area: true,
			current_quarter_number: 2,
			level_chart_1: 1,
			level_chart_2: 1,
			cerrent_area: null,
			dealer_code_list: null,
			quarter_number: null
		}
	}
	componentDidMount() {
		var _rg_setting = Ls.get("rg_setting")
		var rg_setting = (_rg_setting && _rg_setting.data != undefined) ? _rg_setting.data : true
		this.setState({
			select_region_service_area: rg_setting
		})
	}
	callbackChangelevelChart1 = (data) => {
		if (this.state.level_chart_1 == 1) {
			this.setState({
				level_chart_1: data.level,
				quarter_name: data.quarter_name.replace("<br/>", ""),
				quarter_number: data.quarter_number,
				range_name: data.range_name,
				range_point: data.range_point
			})
		} else if (this.state.level_chart_1 == 2) {
			this.setState({
				level_chart_1: data.level,
				dealer_name: data.name,
				data_customer_list: data.data_customer_list
			})
		}

	}
	callbackChangelevelChart2 = (data) => {
		if (this.state.level_chart_2 == 1) {
			this.setState({
				level_chart_2: data.level,
				cerrent_area: data.data.name,
				dealer_code_list: data.data.dealer_code,
				quarter_number: data.quarter_number,
				mid_nps: data.data.data["qtr" + data.quarter_number].nps_os
			})
		}

	}
	goback() {
		this.setState({
			level_chart_1: this.state.level_chart_1 - 1
		})
	}
	goback2() {
		this.setState({
			level_chart_2: this.state.level_chart_2 - 1
		})
	}
	handleChange = (key, val) => {
		this.setState({
			[key]: val
		}, () => {
			if (key == "select_region_service_area") {
				Ls.set("rg_setting", val)
			}
		})
	}
	render() {
		return (
			<div className={"card-space"}>
				<hr className="hr-s-m-0" />
				<span className="">
					<span>{Lg.ts("เลือกการจัดกลุ่มข้อมูล")} : </span>
					<FormControlLabel
						control={
							<Checkbox
								checked={this.state.select_region_service_area}
								onChange={e => this.handleChange("select_region_service_area", true)}
								name="checkedB"
								color="primary"
							/>
						}
						label={Lg.ts("ตาม Nissan แบ่งพื้นที่บริการ")}
					/>
					<FormControlLabel
						control={
							<Checkbox
								checked={!this.state.select_region_service_area}
								onChange={e => this.handleChange("select_region_service_area", false)}
								name="checkedB"
								color="primary"
							/>
						}
						label={Lg.ts("ตามภูมิประเทศ")}
					/>
				</span>
				<hr className="hr-s-m-0" />
				<GridContainer justify="center">
					<GridItem xs={12}>

						<center>
							<h3><b>{Lg.ts("NPS Nationwide")}</b></h3>
						</center>
					</GridItem>
					<GridItem xs={12}>
						{
							(this.state.level_chart_1 == 1) ?
								<GridContainer justify="center">
									<GridItem xs={12}>
										<small className="txt-c-dorg2"><i>* {Lg.ts("สามารถกดที่ Chart เพื่อเข้าไปดูข้อมูลต่อได้")}</i></small>
									</GridItem>
									<GridItem xs={12} sm={6}>
										<Chart1 callbackChangelevel={this.callbackChangelevelChart1} />
									</GridItem>
									<GridItem xs={12} sm={6}>
										<Chart2 />
									</GridItem>
								</GridContainer>
								: (this.state.level_chart_1 == 2) ?
									<GridContainer justify="center">
										<GridItem xs={12}>
											<Button
												size="sm"
												round
												variant="outlined"
												onClick={e => this.goback()}
											>
												<ArrowBackIcon />
												{Lg.ts("ย้อนกลับ")}
											</Button>{" "}
											<small className="txt-c-dorg2"><i>* {Lg.ts("สามารถกดที่ Chart เพื่อเข้าไปดูข้อมูลต่อได้")}</i></small>
										</GridItem>
										<GridItem xs={12}>
											<Chart1Detail
												select_region_service_area={this.state.select_region_service_area}
												callbackChangelevel={this.callbackChangelevelChart1}
												quarter_name={this.state.quarter_name}
												quarter_number={this.state.quarter_number}
												range_name={this.state.range_name}
												range_point={this.state.range_point}
											/>
										</GridItem>
									</GridContainer>
									:
									<GridContainer justify="center">
										<GridItem xs={12}>
											<Button
												size="sm"
												round
												variant="outlined"
												onClick={e => this.goback()}
											>
												<ArrowBackIcon />
												ย้อนกลับ
											</Button>{" "}
										</GridItem>
										<GridItem xs={12}>
											<Chart1DetailL2
												quarter_name={this.state.quarter_name}
												dealer_name={this.state.dealer_name}
												range_name={this.state.range_name}
												data_customer_list={this.state.data_customer_list}
											/>
										</GridItem>
									</GridContainer>
						}

						<hr className="hr-s" />
						<GridContainer justify="center">
							<GridItem xs={12} >
								<Chart1NPS
									select_region_service_area={this.state.select_region_service_area}
								/>
							</GridItem>
						</GridContainer>
						<hr className="hr-s" />
						<br />
						{
							(this.state.level_chart_2 == 1) ?
								<GridItem xs={12}>
									<small className="txt-c-dorg2"><i>* สามารถกดที่ Chart เพื่อเข้าไปดูข้อมูลต่อได้</i></small>
									<Chart1L2
										select_region_service_area={this.state.select_region_service_area}
										callbackChangelevel={this.callbackChangelevelChart2}
									/>
								</GridItem>
								:
								(this.state.level_chart_2 == 2) ?
									<GridItem xs={12}>
										<Button
											size="sm"
											round
											variant="outlined"
											onClick={e => this.goback2()}
										>
											<ArrowBackIcon />
											ย้อนกลับ
										</Button>{" "}
										<Chart1L3
											callbackChangelevel={this.callbackChangelevelChart2}
											quarter_number={this.state.quarter_number}
											cerrent_area={this.state.cerrent_area}
											dealer_code_list={this.state.dealer_code_list}
											mid_nps={this.state.mid_nps}
										/>
									</GridItem>
									: null
						}
					</GridItem>
					<GridItem xs={12} >
						<hr className="hr-s" />
					</GridItem>
					<GridItem xs={12}>
						<center>
							<h3><b>NPS by  Top 10 & Bottom 10 (ALL)</b></h3>
						</center>
					</GridItem>
					<GridItem xs={12} sm={12}>
						<Chart3 quarter_number={this.state.current_quarter_number} />
					</GridItem>
					<GridItem xs={12} sm={12}>
						<Chart4 quarter_number={this.state.current_quarter_number} />
					</GridItem>
				</GridContainer>
			</div>
		);
	}
}

export default PChart;